import templateUrl from './detectorEventTable.tpl.html';

export const detectorEventTable = [
    'eventModal',
    'alertingService',
    'alertTypeService',
    'detectorPriorityService',
    '$location',
    'featureEnabled',
    function (
        eventModal,
        alertingService,
        alertTypeService,
        detectorPriorityService,
        $location,
        featureEnabled
    ) {
        return {
            scope: {
                detectorEvents: '=',
                pinTime: '=',
                createNewEvent: '=',
                hasEventsTab: '=',
            },
            restrict: 'E',
            templateUrl,
            link: function (scope) {
                function getDashboardNavigationContext() {
                    const currentPath = $location.path();
                    if (
                        !currentPath.startsWith('/dashboard/') &&
                        !currentPath.startsWith('/page/')
                    ) {
                        return undefined;
                    }

                    return alertingService.createAlertDetailsNavigationContext({
                        dashboardUrl: alertingService.getDashboardNavigationUrl(
                            currentPath,
                            $location.search()
                        ),
                    });
                }

                scope.showEventDetails = function (event) {
                    const navigationContext = getDashboardNavigationContext();

                    if (
                        featureEnabled('o11yAIITPageDefault') &&
                        event?.metadata?.sf_eventCategory === 'ALERT' &&
                        event?.id
                    ) {
                        alertingService.navigateToAlertDetails(event.id, navigationContext);
                        return;
                    }

                    eventModal(event);
                };

                scope.getAlertClass = function (severity) {
                    return detectorPriorityService.getAlertClassBySeverity(severity);
                };

                scope.getDisplayText = function (state) {
                    return alertTypeService.getDisplayFor(state);
                };

                scope.isClearingEvent = function (state) {
                    return alertTypeService.isClearingEvent(state);
                };
            },
        };
    },
];
